
import Btn from "./Btn";
import Product from "./Product";
import {mapMutations} from "vuex";
import SizeSelect from "./SizeSelect.vue";
import BtnFavorite from "./BtnFavorite.vue";
export default {
    components: {BtnFavorite, SizeSelect, Product, Btn},

    props: ['product', 'h1', 'colorVariations'],
    data() {
        return {
            tab: 'info',
            imageCurrent: null,
            imageCurrentIndex: null,
            size: null,
            error: null,
            process: false,
            success: false,
            lightbox: {
                index: 0,
                visible: false,
            },
        }
    },
    created() {
        if(this.product){
            this.imageCurrent = this.product.image;
            this.imageCurrentIndex = 0;
        }
    },
    mounted() {
        if (this.$ecommerce && this.product) {
            this.$ecommerce.detail(this.product);
            if (this.product.has_link_products) {
                this.$ecommerce.impressions(
                    this.product.link_products.map(item => item.product),
                    'Linked products'
                );
            }
        }
    },
    computed: {
        isAdmin() {
            return Boolean(this.$auth && this.$auth.loggedIn && this.$auth.user && this.$auth.user.role === 'admin');
        },
        adminProductEditUrl() {
            return `/admin/resource/product-resource/form-page/${this.product.id}`;
        },
        canViewStockDetails() {
            if (!this.$auth || !this.$auth.loggedIn || !this.$auth.user) {
                return false;
            }

            return this.isAdmin || Boolean(this.$auth.user.has_product_stock_access);
        },
        priceFormated() {
            return new Intl.NumberFormat('ru-RU').format(this.product.price);
        },
        priceBaseFormated() {
            return new Intl.NumberFormat('ru-RU').format(this.product.price_base);
        },
        hasColorVariations() {
            return Array.isArray(this.colorVariations) && this.colorVariations.length > 0;
        },
        btn_name(){
            if(this.error){
                return this.error;
            }
            if(this.success){
                return 'Добавлено';
            }
            return 'В корзину';
        },
        lightboxImages(){
            let images = [];
            if(this.product.image){
                images.push(this.product.image.sizes.big);
            }
            if(!this.product.has_add_images){
                return images;
            }

            for(let i = 0; i < this.product.add_images.length; i++){
                images.push(this.product.add_images[i].image.sizes.big);
            }
            return images;
        },
        all_images(){
            if(!this.product.has_add_images){
                return [];
            }

            let images = [];
            if(this.product.image){
                images.push(this.product.image);
            }
            this.product.add_images.forEach(function (item) {
                images.push(item.image);
            })

            return images;

        },
        stocksBySize() {
            if (!this.canViewStockDetails || !this.product || !this.product.has_sizes || !Array.isArray(this.product.sizes)) {
                return [];
            }

            return this.product.sizes
                .filter(size => {
                    const hasQuantity = size && size.quantity !== undefined && size.quantity !== null;
                    const hasWarehouses = Array.isArray(size.warehouses_quantity) && size.warehouses_quantity.length > 0;
                    return hasQuantity || hasWarehouses;
                })
                .map(size => ({
                    id: size.id,
                    name: size.size,
                    quantity: size.quantity,
                    warehouses: Array.isArray(size.warehouses_quantity) ? size.warehouses_quantity : [],
                }));
        },
        showStocksBySize() {
            return this.stocksBySize.length > 0;
        },
        totalStock() {
            if (!this.canViewStockDetails || !this.product) {
                return null;
            }

            if (this.product.quantity === undefined || this.product.quantity === null) {
                if (this.product.has_sizes && Array.isArray(this.product.sizes)) {
                return this.product.sizes.reduce((acc, size) => {
                    if (!size || size.quantity === undefined || size.quantity === null) {
                        return acc;
                    }
                    return acc + size.quantity;
                }, 0);
                }

                return null;
            }

            return this.product.quantity;
        },
        warehousesTotals() {
            if (!this.canViewStockDetails || !this.product) {
                return [];
            }

            if (Array.isArray(this.product.warehouses_quantity)) {
                return this.product.warehouses_quantity;
            }

            return [];
        },
        warehousesAvailability() {
            if (!this.product || !Array.isArray(this.product.warehouses_availability)) {
                return [];
            }

            return this.product.warehouses_availability.map(warehouse => ({
                id: String(warehouse.id),
                name: warehouse.name || warehouse.id,
                available: Boolean(warehouse.available),
            }));
        },
        warehousesBySize() {
            if (!this.product || !this.product.has_sizes || !Array.isArray(this.product.sizes)) {
                return [];
            }

            return this.product.sizes
                .filter(size => Array.isArray(size.warehouses_availability) && size.warehouses_availability.length)
                .map(size => ({
                    id: size.id,
                    name: size.size,
                    warehouses: size.warehouses_availability.map(warehouse => ({
                        id: String(warehouse.id),
                        name: warehouse.name || warehouse.id,
                        available: Boolean(warehouse.available),
                    })),
                }));
        },
        warehouseColumns() {
            if (!this.canViewStockDetails) {
                return [];
            }

            if (this.warehousesTotals.length) {
                return this.warehousesTotals.map(warehouse => ({
                    id: String(warehouse.id),
                    name: warehouse.name || warehouse.id,
                }));
            }

            const sizeWarehouses = this.stocksBySize.find(stock => Array.isArray(stock.warehouses) && stock.warehouses.length);
            if (sizeWarehouses) {
                return sizeWarehouses.warehouses.map(warehouse => ({
                    id: String(warehouse.id),
                    name: warehouse.name || warehouse.id,
                }));
            }

            return [];
        },
        warehouseColumnsPublic() {
            if (this.warehousesAvailability.length) {
                return this.warehousesAvailability.map(warehouse => ({
                    id: String(warehouse.id),
                    name: warehouse.name || warehouse.id,
                }));
            }

            const sizeWarehouses = this.warehousesBySize.find(size => Array.isArray(size.warehouses) && size.warehouses.length);
            if (sizeWarehouses) {
                return sizeWarehouses.warehouses.map(warehouse => ({
                    id: String(warehouse.id),
                    name: warehouse.name || warehouse.id,
                }));
            }

            return [];
        },
        showStocks() {
            if (!this.canViewStockDetails) {
                return false;
            }

            if (this.showStocksBySize) {
                return true;
            }

            if (this.totalStock !== null) {
                return true;
            }

            return this.warehouseColumns.length > 0;
        },
        showWarehousesAvailability() {
            if (this.canViewStockDetails) {
                return false;
            }

            return this.warehousesAvailability.length > 0 || this.warehousesBySize.length > 0;
        },
        showWarehousesAvailabilityBySize() {
            if (this.canViewStockDetails) {
                return false;
            }

            return this.warehousesBySize.length > 0 && this.warehouseColumnsPublic.length > 0;
        },
        isAvailableForSale() {
            if (!this.product) {
                return false;
            }

            if (this.product.available !== undefined && this.product.available !== null) {
                return Boolean(this.product.available);
            }

            if (this.product.quantity !== undefined && this.product.quantity !== null) {
                return this.product.quantity > 0;
            }

            if (this.product.has_sizes) {
                return Array.isArray(this.product.sizesToBuy) && this.product.sizesToBuy.length > 0;
            }

            return true;
        },
    },
    methods:{
        ...mapMutations({
            setBasketCount: 'setBasketCount',
        }),
        getWarehouseQuantity(warehouses, id){
            if (!Array.isArray(warehouses)) {
                return 0;
            }

            const warehouse = warehouses.find(item => String(item.id) === String(id));
            return warehouse ? warehouse.quantity : 0;
        },
        getWarehouseAvailability(warehouses, id){
            if (!Array.isArray(warehouses)) {
                return false;
            }

            const warehouse = warehouses.find(item => String(item.id) === String(id));
            return Boolean(warehouse && warehouse.available);
        },
        setSize(size){
            this.size = size;
        },
        setImage(image, index){
            this.imageCurrent = image;
            this.imageCurrentIndex = index;
        },
        showLightboxImage(){
            if (this.imageCurrentIndex === null) {
                return;
            }

            this.lightbox.index = this.imageCurrentIndex;
            this.lightbox.visible = true;
        },
        lightboxHide(){
            this.lightbox.visible = false;
        },
        async buy(){
            if(this.product.has_sizes && !this.size){
                this.error = 'Выберите размер';
                setTimeout(this.clearError, 5000);

                return;
            }

            try{
                const {data: response} = await this.$axios.post('api/v1/product/buy', {
                    id: this.product.id, count: 1,
                    size: this.size ? this.size.id : null,
                    sizeName: this.size ? this.size.size : null
                });
                this.success = true;
                this.error = null;
                this.setBasketCount(response.count);
                if (this.$ecommerce) {
                    this.$ecommerce.add(this.product, {
                        quantity: 1,
                        size: this.size,
                    });
                }
                setTimeout(this.clearSuccess, 5000);
            } catch (e) {
                if (e.response.status === 404) {
                    this.error = 'Товар не найден';
                }
                else if (e.response.status === 422) {
                    this.error = 'Ошибка';
                } else {
                    this.error = 'Ошибка';
                }
                setTimeout(this.clearError, 5000);
            }
        },
        clearError(){
            this.error = null;
            this.success = false;
            this.process = false;
        },
        clearSuccess(){
            this.size = null;
            this.error = null;
            this.success = false;
            this.process = false;
        },
    },
}
